import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface DialogData {
  offerSub: string;
}


@Component({
  selector: 'app-opendialog-offer-details',
  templateUrl: './opendialog-offer-details.component.html',
  styleUrls: ['./opendialog-offer-details.component.scss']
})
export class OpendialogOfferDetailsComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<OpendialogOfferDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData

  ) { }

  ngOnInit(): void {
  }

}
